import check_url_is_ajax from "frontend/navigation/check_url_is_ajax"
import start_request from "frontend/navigation/start_request"

export default url => {
  if (check_url_is_ajax(url)) {
    start_request(url, {})
  } else {
    window.location = url
  }
}
